// ** React Imports
import { Fragment, useEffect, useState } from "react";

// ** Reactstrap Imports
import {
  Alert,
  Button,
  Col,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";

import { Controller, useForm } from "react-hook-form";

// ** Styles
import Select from "react-select";

import { ErrorHandler, ExtractError } from "../../../common/utils/Error";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAllbookings } from "../../../redux/booking";
import moment from "moment";
import toast from "react-hot-toast";

const ReceiptModel = ({ show, onClose, invoice }) => {
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);

  const defaultValues = {
    receipt_date: moment().format("YYYY-MM-DD"),
    invoice: invoice?._id,
    account: null,
  };

  const {
    register,
    reset,
    control,
    setError,
    clearErrors,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const getAccounts = async () => {
    try {
      var { status, data } = await axios.get(
        "/accountings/accounts/hierarchy/64089b489d122d411c67abe4"
      );
      if (status == 200) {
        setAccounts(data?.data ?? []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setValue("receipt_date", moment().format("YYYY-MM-DD"));
    setValue("invoice", invoice?._id);
    setValue("amount", invoice?.balance);
    getAccounts();
  }, [show, invoice]);

  const onSubmit = async (data) => {
    try {
      setErrorMessage(null);
      setLoading(true);
      if (data.amount > invoice.balance) {
        throw new Error("Paid Amount must be less than amount");
      }

      data.account = data.account?.value;

      var response = await axios.post("/accountings/receipts", {
        ...data,
        type: "single",
      });

      if (response.status === 200) {
        onClose();
        toast.success("Receipt Successfully");
      }
    } catch (error) {
      setErrorMessage(ExtractError(error));
    } finally {
      setLoading(false);
    }
  };

  const onDiscard = () => {
    clearErrors();
    reset();
    onClose();
  };
  return (
    <Fragment>
      <Modal
        isOpen={show}
        onClosed={onDiscard}
        toggle={onClose}
        className=""
        centered
      >
        <ModalHeader toggle={onClose} className="bg-white">
          Make Receipt
        </ModalHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody className="">
            {errorMessage && (
              <Alert color="danger" className="px-2 py-1">
                {errorMessage}
              </Alert>
            )}

            <Row className="gy-1 gx-2 flex-column mb-1">
              <Col xs={12}>
                <Label className="form-label" for="amount">
                  Amount
                </Label>
                <Controller
                  name="amount"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Input
                      id="amount"
                      type="text"
                      invalid={errors.amount && true}
                      {...field}
                    />
                  )}
                />
                {errors.amount && (
                  <FormFeedback>Please enter Amount</FormFeedback>
                )}
              </Col>
              <Col xs={12}>
                <Label className="form-label" for="account">
                  Deposit to
                </Label>
                <Controller
                  name="account"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Select
                      id="account"
                      className="react-select"
                      classNamePrefix="select"
                      invalid={errors.account && true}
                      {...register("account", { required: true })}
                      {...field}
                      options={accounts.map((ac) => ({
                        value: ac._id,
                        label: `${ac.name}`,
                        isDisabled: ac.systemAccount,
                      }))}
                    />
                  )}
                />
                {errors.account && (
                  <FormFeedback>Please enter account</FormFeedback>
                )}
              </Col>
              <Col xs={12}>
                <Label className="form-label" for="receipt_date">
                  Receipt Date
                </Label>
                <Controller
                  name="receipt_date"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Input
                      id="receipt_date"
                      type="date"
                      invalid={errors.receipt_date && true}
                      {...field}
                    />
                  )}
                />
                {errors.receipt_date && (
                  <FormFeedback>Please enter Receipt Date</FormFeedback>
                )}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-end">
            <Button
              type="submit"
              className="me-1"
              color="success"
              disabled={loading}
            >
              <Spinner
                color="light"
                size="sm"
                className="me-1"
                hidden={!loading}
              />
              {loading ? "Submitting..." : "Submit"}
            </Button>
            <Button
              type="reset"
              className=""
              color="secondary"
              outline
              onClick={onDiscard}
            >
              Close
            </Button>
          </ModalFooter>
        </form>
      </Modal>
    </Fragment>
  );
};

export default ReceiptModel;
